var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6504 3.75C18.3502 3.75011 19.0249 4.05015 19.4873 4.5625L21.0371 6.25H25C26.375 6.25 27.5 7.375 27.5 8.75V23.75C27.5 25.125 26.375 26.25 25 26.25H5C3.625 26.25 2.5 25.125 2.5 23.75V8.75C2.5 7.375 3.625 6.25 5 6.25H8.96289L10.5 4.5625C10.9749 4.0501 11.6497 3.75011 12.3496 3.75H17.6504ZM15 9.75098C11.55 9.75098 8.75 12.551 8.75 16.001C8.75026 19.4508 11.5502 22.251 15 22.251C18.4498 22.251 21.2497 19.4508 21.25 16.001C21.25 12.551 18.45 9.75098 15 9.75098ZM15 12.25C17.0711 12.25 18.75 13.9289 18.75 16C18.75 18.071 17.0711 19.75 15 19.75C12.929 19.7499 11.25 18.071 11.25 16C11.25 13.929 12.929 12.2501 15 12.25Z",
    fill: "#585C91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9e9ec52a.svg";
export { ForwardRef as ReactComponent };